export class event  {
  area?: String;
  branch_office?: String;
  category?: String;
  concept?: String;
  event?: String;
  event_date?: String;
  detail?: String;
  action_taken?: String;
  source?: String;
  derived_risk?: String;
  loss?: Number;
  loss_amount?: Number;
  transferred_loss?: Number;
  net_loss?: Number;
  impact?: String;
  probability?: String;
  control?: String;
  x?: Number;
  y?: Number;
  implicit_risk?: Number;
  implicit_risk_level?: String;
  control_2?: Number;
  to_control?: Number;
  exposure_level?: Number;
  recommendation?: String;
  work_plan?: String;
  deadline?: String;
  plan_status?: String;
  event_status?: Number;
  register?: String;
  institution_id?: String;

  constructor(){}
}
export class potential_event  {
  institution_id: String;
  event_date: String;
  area: String;
  process: String;
  risk_type: String;
  category: String;
  concept: String;
  event: String;
  event_detail: String;
  consequence: String;
  source: String;
  derived_risk: String;
  loss: Number;
  loss_amount: Number;
  transferred_loss: Number;
  net_loss: Number;
  impact: String;
  probability: String;
  mitigators: String;
  control_type: String;
  periodicity: String;
  opportunity: String;
  control_effectiveness: String;
  work_plan: String;
  plan_responsible: String;
  start_date: String;
  end_date: String;
  plan_status: String
  
  constructor(){}
}
